import { BusinessUnit } from '../../models/buniessUnitType';
import { CountryType } from '../../models/countryUnitActuals';

export type SelectDataState = {
  selectedCountryCodes: CountryType[];
  loading: boolean;
  error: string | null;
  businessUnits: BusinessUnit[];
  selectedBUs: string[];
};

export const initialState: SelectDataState = {
  selectedCountryCodes: [],
  businessUnits: [],
  selectedBUs: [],
  loading: false,
  error: null,
};
